import { render, staticRenderFns } from "./header-separator.vue?vue&type=template&id=4b61db15&scoped=true&"
import script from "./header-separator.vue?vue&type=script&lang=js&"
export * from "./header-separator.vue?vue&type=script&lang=js&"
import style0 from "./header-separator.vue?vue&type=style&index=0&id=4b61db15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61db15",
  null
  
)

export default component.exports